import { memo } from 'react';

import { EyeClosedIcon, EyeIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { useToggleNestedItems } from '~/hooks/search/useToggleNestedItems';

export const MobileToggleNestedItemsButton = memo(() => {
  const { isFlattenedView, toggleNestedItems } = useToggleNestedItems();

  const label = isFlattenedView ? 'Collapse nested content' : 'Expand nested content';

  return (
    <Tooltip label={label}>
      <IconButton
        adsIcon
        appearance="ghost"
        color={isFlattenedView ? 'blue' : 'gray'}
        data-testid="MOBILE_TOGGLE_NESTED_ITEMS_BUTTON"
        icon={isFlattenedView ? EyeClosedIcon : EyeIcon}
        label={label}
        onClick={toggleNestedItems}
        size="small"
      />
    </Tooltip>
  );
});

MobileToggleNestedItemsButton.displayName = 'MobileToggleNestedItemsButton';
